import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0rem',
    padding: '1rem',
    margin: '1rem',
    marginBottom: '0rem',
    paddingBottom: '0rem',
  },

  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0rem !important',
    margin: '0rem !important',
    padding: '0rem !important',
    marginBottom: '1rem !important',

    '& h1': {
      margin: '0rem !important',
      padding: '0rem !important',
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: '1.5rem',
      fontFamily: 'Nunito !important',

      '& span': {
        fontWeight: 600,
        marginLeft: '0.25rem',
      },
    },
  },

  alert: {
    '& .MuiSvgIcon-root': {
      color: '#0288D1 !important',
    },
  },

  mailContainerImg: {
    width: '15rem',
    height: '10rem',
    marginRight: '0.25rem',
  },

  mailContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem !important',
    margin: '1rem 0rem !important',
    padding: '0rem !important',
    width: '100%',

    '& h1': {
      width: '100%',
      maxWidth: '540px',
      textAlign: 'center',
      margin: '0rem !important',
      padding: '0rem !important',
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: '1.5rem',
      fontFamily: 'Nunito !important',

      '& span': {
        fontWeight: 600,
        marginLeft: '0.25rem',
      },
    },
  },

  inputInvite: {
    width: '100%',
    maxWidth: '540px',
  },
}))

export { useStyles }
